import * as React from "react";
import { FullPage } from "spry-react/Page/fullPage";
import { Page } from "spry-react/Page/page";
import { SiteNavigation, SiteNavigationContextMenuLink } from "spry-react/Page/siteNavigation";
import { SiteHeader } from "spry-react/Page/siteHeader";
import { IPortalAppContext } from "./appContext";
import { ScrollBarAdapter } from "spry-react/Page/scrollBarAdapter";
import { DialogRoots } from "spry-react/DialogPortal/dialogRoots";
import { FullPageLoadingBanner } from "./fullPageLoadingBanner";
import { PortalSiteLinks } from "./portalSiteLinks";
import { ContextMenu, ContextMenuItem } from 'spry-react/ContextMenu/contextMenu';
import { AccountSettingsUrls } from "Components/AccountSettings/accountSettingsRoutes";
import { ClaimsUrls } from "Components/Claims/claimsRoutes";
import { PaymentsUrls } from "Components/PaymentHistory/paymentHistoryRoutes";
import { ManageUsersUrls } from "Components/ManageUsers/manageUsersRoutes";

export interface Props {
  title: string;
  headerContent?: React.ReactNode;
  children?: React.ReactNode;
  borderedHeader?: boolean;
  context: IPortalAppContext;
  noClientSideUrls?: boolean;
}

export class PortalHeader extends React.PureComponent<Props> {
  render() {
    const siteLinks = <PortalSiteLinks {...this.props} />
    const navContent = <PortalSiteNavigation {...this.props} />;

    return (
      <>
        <FullPageLoadingBanner />
        <div>
          <section id="site-top">
            <SiteNavigation siteLinksContent={siteLinks} navContent={navContent} />
          </section>
          <SiteHeader
            logoImageUrl={this.props.context.portalSiteLinks.logoImageUrl}
            bordered={this.props.borderedHeader}
            children={this.props.headerContent}
          />
        </div>
      </>
    );
  }
}

export class PortalFullPage extends React.PureComponent<Props> {
  componentDidMount() {
    (Matrix as any).useLegacyMultiselectHandler = false;
  }

  render() {
    const header = <PortalHeader {...this.props} />;
    return <FullPage header={header} {...this.props.context} {...this.props} title={this.props.title + ' - MatrixSAFE Portal'} />;
  }
}

export class PortalPage extends React.PureComponent<Props> {
  componentDidMount() {
    (Matrix as any).useLegacyMultiselectHandler = false;
  }

  render() {
    const header = <PortalHeader {...this.props} />;
    return <Page header={header} {...this.props.context} {...this.props} title={this.props.title + ' - MatrixSAFE Portal'} />;
  }
}

export interface PortalSiteNavigationProps {
  context: IPortalAppContext;
}

export class PortalSiteNavigation extends React.Component<PortalSiteNavigationProps> {
  render() {
    return (
      this.props.context.loggedInUser ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ borderLeft: "1px solid rgba(208, 210, 211, 0.1)" }}>
            <SiteNavigationContextMenuLink
              title='Site Main Menu'
              text='Menu'
              iconClassName='open-down-icon'
              renderContextMenu={() => this.buildMenu()}
              id={""} />
          </div>
        </div>
      ) : null
    );
  }

  buildMenu = () => {
    return (
      <>
        <ContextMenu>
          <ContextMenuItem
            clientSideUrl={ClaimsUrls.list()}
            text='Claims'
            icon='list'
          />
          <ContextMenuItem
            clientSideUrl={PaymentsUrls.history()}
            text='Payment History'
            icon='submission-history'
          />
          {this.props.context.loggedInUser?.isAdmin === true &&
          <ContextMenuItem
            clientSideUrl={ManageUsersUrls.manageUsers()}
            text='Manage Users'
            icon='disk-storage-3'
          />
          }
          <ContextMenuItem
            clientSideUrl={AccountSettingsUrls.settings()}
            text='Account Settings'
            icon='settings'
          />
          <ContextMenuItem
            url="/logout"
            text='Logout'
            icon='logout'
          />
        </ContextMenu>
      </>
    );
  };
}
